import { ENV } from '@/constants';
import { exploreSchemaItemList } from '../exploreSchema';

export const schemaObject_CutoutImage = {
	'@context': 'https://schema.org',
	'@graph': [
		{
			'@type': 'WebPage',
			'@id': 'https://liftapp.ai/cutout-image',
			name: 'Cut Out Photo | Image Cutout Background Remover | Lift',
			description:
				'Cut photo out of background instantly with AI. Online picture cut out tool — no watermarks, batch up to 20 images. Cut out pic backgrounds in seconds with Lift.',
			url: 'https://liftapp.ai/cutout-image',
			image: 'https://liftapp.ai/seo-image.webp',
			mainEntity: [
				{ '@id': 'https://liftapp.ai/cutout-image#product' },
				{ '@id': 'https://liftapp.ai/cutout-image#howto' },
				{ '@id': 'https://liftapp.ai/cutout-image#benefits' },
				{ '@id': 'https://liftapp.ai/cutout-image#faq' },
				{ '@id': 'https://liftapp.ai/cutout-image#why-lift' },
				{ '@id': 'https://liftapp.ai/cutout-image#explore-tools' },
				{ '@id': 'https://liftapp.ai/cutout-image#all-in-one' },
			],
		},
		// product
		{
			'@type': 'Product',
			'@id': 'https://liftapp.ai/cutout-image#product',
			name: 'Cut Out Image with AI',
			description:
				'Cut photo out of background instantly. Online AI cutout tool removes backgrounds and creates transparent PNGs in seconds. No design skills needed.',
			url: 'https://liftapp.ai/cutout-image',
			fileFormat: ['image/jpeg', 'image/png', 'image/webp'],
			memoryRequirements: 'Max file size: 20MB',
			brand: {
				'@type': 'Brand',
				name: 'Lift',
			},
			aggregateRating: {
				'@type': 'AggregateRating',
				ratingValue: '4.8',
				reviewCount: 130000,
				bestRating: '5',
				worstRating: '1',
			},
			interactionStatistic: [
				{
					'@type': 'InteractionCounter',
					interactionType: { '@type': 'InstallAction' },
					userInteractionCount: 13000000,
				},
			],
		},
		// howto
		{
			'@type': 'HowTo',
			'@id': 'https://liftapp.ai/cutout-image#howto',
			name: 'How it works',
			step: [
				{
					'@type': 'HowToStep',
					position: 1,
					name: 'Upload your photos',
					text: "Choose a photo from your device or take one using Lift's app",
				},
				{
					'@type': 'HowToStep',
					position: 2,
					name: 'Let the AI do the work',
					text: 'Watch as Lift cuts out your image automatically',
				},
				{
					'@type': 'HowToStep',
					position: 3,
					name: 'Customize adjustments',
					text: 'Fine-tune your image with easy-to-use editing tools',
				},
				{
					'@type': 'HowToStep',
					position: 4,
					name: 'Download and use',
					text: 'Download your image or publish it straight to your social feeds',
				},
			],
		},
		// benefit
		{
			'@type': 'ItemList',
			'@id': 'https://liftapp.ai/cutout-image#benefits',
			name: 'Who can benefit from AI Photo Cutter?',
			description:
				"Lift's AI Photo Cutter is useful for professionals, creators, and businesses who want clean, distraction-free images for social media, e-commerce, marketing, or personal use.",
			itemListOrder: 'Unordered',
			itemListElement: [
				{
					'@type': 'ListItem',
					position: 1,
					name: '**E-commerce sellers** — Cut picture backgrounds to create professional product photos for Amazon, Shopify, or Etsy. Clean cutout images boost conversions and build buyer trust with consistent, distraction-free listings',
				},
				{
					'@type': 'ListItem',
					position: 2,
					name: '🔹 **Content creators** — Cut out photos for Instagram stories, YouTube thumbnails, and TikTok videos. Picture cut out tool helps you create eye-catching collages, memes, and designs that stop the scroll and grow your audience',
				},
				{
					'@type': 'ListItem',
					position: 3,
					name: '🔹 **Freelance designers** — Cut image backgrounds online to speed up client projects. Deliver polished cutout pictures faster, handle more jobs, and increase your earnings without manual photo editing',
				},
				{
					'@type': 'ListItem',
					position: 4,
					name: '🔹 **Small business owners** — Photo cut out tool for creating marketing materials, social media posts, and promotional graphics. Cut out images for flyers, ads, and presentations without hiring a designer',
				},
				{
					'@type': 'ListItem',
					position: 5,
					name: '🔹 **Students & educators** — image cutout for school projects, presentations, and creative assignments. Cut around images to make professional-looking posters, reports, and digital portfolios.',
				},
			],
			image: {
				'@type': 'ImageObject',
				contentUrl:
					'https://liftapp.ai/_next/static/media/benefits.3da6de53.webp',
				name: 'Cut Background Out Of Photo',
				description:
					'Example of how Lift AI Photo Cutter creates clean, professional images by cutting out backgrounds.',
			},
		},

		// faq
		{
			'@type': 'FAQPage',
			'@id': 'https://liftapp.ai/cutout-image#faq',
			mainEntity: [
				{
					'@type': 'Question',
					name: 'What is Lift AI Photo Cutter?',
					acceptedAnswer: {
						'@type': 'Answer',
						text: 'Lift AI Photo Cutter is a premium online tool that instantly removes image backgrounds with pixel-perfect precision — ideal for product photos, profile pictures, or graphic design.',
					},
				},
				{
					'@type': 'Question',
					name: 'How does Lift AI Photo Cutter work?',
					acceptedAnswer: {
						'@type': 'Answer',
						text: "Simply upload your photo to Lift's image cutout tool. Our AI automatically detects the subject and cuts out the background in seconds — no photo editing experience needed. Download up to 20 cutout pictures with transparent PNG backgrounds.",
					},
				},
				{
					'@type': 'Question',
					name: 'Will it keep hair, edges, and fine details?',
					acceptedAnswer: {
						'@type': 'Answer',
						text: 'Yes. Lift AI Photo Cutter uses advanced edge detection to preserve delicate elements like hair, fur, shadows, and soft textures — so you get clean, natural-looking cutouts without manual touch-ups.',
					},
				},
				{
					'@type': 'Question',
					name: 'Can I download the results without a watermark?',
					acceptedAnswer: {
						'@type': 'Answer',
						text: "Absolutely. All images generated or edited in Lift can be exported without watermark when you're on the Pro plan. Download them in high-res PNG or JPG — ready for social media, print, ads, or e-commerce.",
					},
				},
			],
		},

		// why lift
		{
			'@type': 'ItemList',
			'@id': 'https://liftapp.ai/cutout-image#why-lift',
			name: "Why Lift's AI Photo Cutter stands out",
			description:
				"Lift's Photo Cutter combines professional-grade AI, ease of use, and affordability — making it a trusted choice for millions of users worldwide.",
			itemListOrder: 'Unordered',
			itemListElement: [
				{
					'@type': 'ListItem',
					position: 1,
					name: 'High-quality results',
					description:
						'AI-powered technology delivers professional-grade visuals every time',
				},
				{
					'@type': 'ListItem',
					position: 2,
					name: 'Intelligent rendering',
					description:
						'AI tailors the effect to the scene and subject for optimal results',
				},
				{
					'@type': 'ListItem',
					position: 3,
					name: 'Cross-platform support',
					description: 'Available on iOS, Android, and Web for seamless access',
				},
				{
					'@type': 'ListItem',
					position: 4,
					name: 'Budget-friendly',
					description:
						'Save on costly designers with an affordable and intuitive tool',
				},
			],
			image: {
				'@type': 'ImageObject',
				contentUrl:
					'https://liftapp.ai/_next/static/media/whyUse.ae83a89c.webp',
				name: 'Cut An Image Out Of A Picture',
				description:
					"Comparison of Lift's AI Photo Cutter benefits — professional quality, AI accuracy, multi-platform access, and cost savings.",
			},
		},
		// explore
		{
			'@type': 'ItemList',
			'@id': 'https://liftapp.ai/cutout-image#explore-tools',
			name: 'Explore the AI tools',
			description:
				'A curated list of AI-powered tools for image generation, enhancement, background removal, and more – all available on Lift.',
			itemListOrder: 'Unordered',
			...exploreSchemaItemList,
		},

		{
			'@type': 'SoftwareApplication',
			'@id': 'https://liftapp.ai/cutout-image#all-in-one',
			name: 'Try Lift – AI Content Creation Tools',
			description:
				'Your all-in-one tools to create, edit, and elevate your content. Create stunning content with AI tools, templates, and editing features effortlessly.',
			operatingSystem: 'iOS, Android, Web',
			applicationCategory: 'MultimediaApplication',
			url: `${ENV.LIFT_WEB_APP_URL}/sign-in?auto_login=true`,
			applicationSubCategory: 'Content Creation',
			publisher: {
				'@type': 'Organization',
				name: 'Lift',
				url: 'https://liftapp.ai',
			},
			potentialAction: [
				{
					'@type': 'ViewAction',
					name: 'Open Web App',
					target: `${ENV.LIFT_WEB_APP_URL}/sign-in?auto_login=true`,
				},
			],
		},

		{
			'@type': 'BreadcrumbList',
			itemListElement: [
				{
					'@type': 'ListItem',
					position: 1,
					name: 'Home',
					item: 'https://liftapp.ai',
				},
				{
					'@type': 'ListItem',
					position: 2,
					name: 'Cut Out Image',
					item: 'https://liftapp.ai/cutout-image',
				},
			],
		},
	],
};
